import { Box, DialogTitle, IconButton, useTheme } from "@fxc/ui-kit";
import { Close as CloseIcon } from "@fxc/ui-kit/icons";

export interface DialogTitleProps {
  children?: React.ReactNode;
  onClose?: () => void;
}

export const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;
  const theme = useTheme();

  return (
    <DialogTitle
      sx={{
        minHeight: 50,
        bgcolor: theme.palette.primary.main,
        color: "white",
      }}
      {...other}
      data-qa={"dialog-title"}
    >
      <Box sx={{ mr: 3 }}>{children}</Box>

      {onClose ? (
        <IconButton
          data-qa="close"
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 2,
            top: 2,
            color: "lightgray",
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
